module.exports = __webpack_public_path__ + "img/help-main-window.2bf91471.webp";